<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="pro_partenariat"
      v-model="sasInscriptionTableau.declarationDUnePratiqueAvanceeEnPartenariat"
      :live="liveSasInscriptionTableau(7708)"
    />
    <CatalogueLive
      code="pratique_public"
      v-model="sasInscriptionTableau.exerceAupresDuPublic"
      :live="liveSasInscriptionTableau(7713)"
    />
    <CatalogueLive
      code="pratique_type"
      v-model="sasInscriptionTableau.exercePharmacienEnTantQue"
      :live="liveSasInscriptionTableau(7714)"
      :opq-if="estOui(sasInscriptionTableau.exerceAupresDuPublic)"
    />

    <CatalogueLive
      code="preparation_locaux_steriles_ouinon"
      v-model="sasInscriptionTableau.locauxPreparationProduitsSteriles"
      :live="liveSasInscriptionTableau(7731)"
      :opq-if="exercePublicProprietaireOuHospitalier"
    />
    <CatalogueLive
      code="preparation_locaux_steriles_adresses"
      :items="sasPratiquesProfessionnelles?.map(getTextSasPratiqueProfessionnelDropdown)"
      v-model="lieux.locauxPreparationProduitsSteriles"
      :live="liveLieuxExercice(29107)"
      :opq-if="estOui(sasInscriptionTableau.locauxPreparationProduitsSteriles)"
    />

    <CatalogueLive
      code="preparation_locaux_magistrales_ouinon"
      v-model="sasInscriptionTableau.locauxPreparationMagistralesNonSterilesCategories2Ou3"
      :live="liveSasInscriptionTableau(7732)"
      :opq-if="exercePublicProprietaireOuHospitalier"
    />
    <CatalogueLive
      code="preparation_locaux_magistrales_adresses"
      :items="sasPratiquesProfessionnelles?.map(getTextSasPratiqueProfessionnelDropdown)"
      v-model="lieux.locauxPreparationMagistrales"
      :live="liveLieuxExercice(29108)"
      :opq-if="estOui(sasInscriptionTableau.locauxPreparationMagistralesNonSterilesCategories2Ou3)"
    />

    <CatalogueLive
      code="autochtone_services_ouinon"
      v-model="sasInscriptionTableau.servicesCommunauteAutochtone"
      :live="liveSasInscriptionTableau(7726)"
      :opq-if="exercePublicProprietaire"
    />
    <CatalogueLive
      code="autochtone_services_adresses"
      :items="sasPratiquesProfessionnelles?.map(getTextSasPratiqueProfessionnelDropdown)"
      v-model="lieux.servicesCommunauteAutochtone"
      :live="liveLieuxExercice(29109)"
      :opq-if="estOui(sasInscriptionTableau.servicesCommunauteAutochtone)"
    />
    <CatalogueLive
      code="autochtone_entente_ouinon"
      v-model="sasInscriptionTableau.ententeCommunauteAutochtone"
      :live="liveSasInscriptionTableau(7728)"
      :opq-if="estOui(sasInscriptionTableau.servicesCommunauteAutochtone)"
    />

    <CatalogueLive
      code="detention_services_ouinon"
      v-model="sasInscriptionTableau.servicesEtablissementDeDetention"
      :live="liveSasInscriptionTableau(7729)"
      :opq-if="exercePublicProprietaire"
    />
    <CatalogueLive
      code="detention_services_adresses"
      :items="sasPratiquesProfessionnelles?.map(getTextSasPratiqueProfessionnelDropdown)"
      v-model="lieux.servicesEtablissementDeDetention"
      :live="liveLieuxExercice(29110)"
      :opq-if="estOui(sasInscriptionTableau.servicesEtablissementDeDetention)"
    />
    <CatalogueLive
      code="detention_entente_ouinon"
      v-model="sasInscriptionTableau.ententeEtablissementDeDetention"
      :live="liveSasInscriptionTableau(7730)"
      :opq-if="estOui(sasInscriptionTableau.servicesEtablissementDeDetention)"
    />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object },
  },
  data() {
    return {
      lieux: {
        locauxPreparationProduitsSteriles: [],
        locauxPreparationMagistrales: [],
        servicesCommunauteAutochtone: [],
        servicesEtablissementDeDetention: [],
      },
    }
  },
  mounted() {
    Object.keys(this.lieux).forEach((rubrique) => {
      this.lieux[rubrique] = this.getIdsLieuxCoches(rubrique)
    })
  },
  computed: {
    sasInscriptionTableau() {
      return this.sas.sasInscriptionTableau
    },
    sasPratiquesProfessionnelles() {
      return this.sas.sasPratiquesProfessionnelles
    },
    exercePublicProprietaire() {
      return this.exerceAupresDuPublicEnTantQue("proprietaire")
    },
    exercePublicProprietaireOuHospitalier() {
      return this.exerceAupresDuPublicEnTantQue("proprietaire", "hospitalier")
    },
  },
  methods: {
    liveSasInscriptionTableau(cle) {
      return { endpoint: "sas-inscription-tableau", cle: cle, fileId: this.sasInscriptionTableau.id }
    },
    liveLieuxExercice(cle) {
      return { endpoint: "sas-pratique-professionnelle/lieux-exercice", cle: cle, fileId: this.sas.id }
    },
    getTextSasPratiqueProfessionnelDropdown(sasPratiqueProfessionnelle) {
      const value = sasPratiqueProfessionnelle.id
      const text = [sasPratiqueProfessionnelle.organisation, sasPratiqueProfessionnelle.rue1, sasPratiqueProfessionnelle.codePostal].filter(s => s).join(" - ")

      return { value, text }
    },
    // Codes du catalogue « Exerce la profession en tant que »
    exerceAupresDuPublicEnTantQue(...codes) {
      return (
        this.estOui(this.sasInscriptionTableau.exerceAupresDuPublic) &&
        (this.sasInscriptionTableau.exercePharmacienEnTantQue ?? []).some((id) =>
          codes.includes(this.getCatalogueCodeById("7714", id))
        )
      )
    },
    getIdsLieuxCoches(rubrique) {
      return this.sasPratiquesProfessionnelles
        ?.filter((s) => s[rubrique])
        .map((s) => s.id)
    }
   }
}
</script>

<style></style>
